import SelectProjectSourcesBody from "@/pages/projects/forms/create/components/steps/select-project-sources/SelectProjectSourcesBody";

const ProjectSelectProjectSourcesStep = () => {
  return <SelectProjectSourcesBody />;
};

export default ProjectSelectProjectSourcesStep;
